import factory from '../requestFactory';
import store from '@/store'

export default ({id}) => {
    let patient_id = store.getters.patient.id
    return factory()
        .get(`/patient/analyzes/analyze-chart-data/${patient_id}/${id}`)

};
